import useNotificationToastsStore from './store';

export default {
  plugin: {
    install(Vue) {
      /* eslint-disable no-param-reassign */
      Vue.prototype.$clyNotify = function (msg) {
        const payload = {};
        let colorToUse;
        payload.text = msg.message;
        payload.autoHide = !msg.sticky;

        switch (msg.type) {
          case 'error':
            colorToUse = 'light-destructive';
            break;
          case 'warning':
            colorToUse = 'light-warning';
            break;
          case 'yellow':
            colorToUse = 'light-warning';
            break;
          case 'info':
          case 'blue':
            colorToUse = 'light-informational';
            break;
          case 'purple':
          case 'ok':
          case 'success':
          default:
            colorToUse = 'light-successful';
            break;
        }
        payload.color = colorToUse;

        useNotificationToastsStore().addNotificationToast(payload);
      };
      /* eslint-enable no-param-reassign */
    },
  },
};
